import React, { useEffect, useState } from "react";
import { Button, Modal, Spin, Upload } from "antd";
import { UserIcon } from "../../../assets/icons";
import { httpService } from "../../../base/services/httpService.service";
import { useNotification } from "../../../base/hooks/useNotification";
import AuthService from "../../../base/services/authentication.service";
import Axios from "axios";
import ImgCrop from "antd-img-crop";
import { useAvatarStore } from "../../../../_metronic/layout/components/header-mobile/store/useAvatarStore";
import { useTranslation } from "../../../i18n/LanguageContext";

const EditProfilePicture = ({ open, onCancel }) => {
   const { t } = useTranslation();
   const [user] = useState(AuthService.getUser());
   const [loading, setLoading] = useState(false);
   const [previewImage, setPreviewImage] = useState(UserIcon);
   const [selectedFile, setSelectedFile] = useState(null);
   const [isDeleted, setIsDeleted] = useState(false);
   const [imageLoading, setImageLoading] = useState(false);
   const { api: notificationApi, notificationContextHolder } = useNotification();

   const [initialImage, setInitialImage] = useState(UserIcon);
   const setProfileImage = useAvatarStore((state) => state.setProfileImage);
   const editProfilePic = async (file = null) => {
      const formData = new FormData();
      if (file) formData.append("file", file);

      try {
         setLoading(true);
         await httpService.put(`Accounts/edit?id=${user?.id}`, formData, (res) => {
            notificationApi.success("user", {
               message: t("profile-picture-updated-success-title"),
               description: t("profile-picture-updated-success-description")
            });
            setProfileImage(previewImage);
            onCancel();
         });
      } catch (error) {
         notificationApi.error("user", {
            message: t("generic-problem-occurred-title"),
            description: t("profile-picture-update-error-description")
         });
      } finally {
         setLoading(false);
      }
   };

   const deleteProfilePic = async () => {
      try {
         setLoading(true);
         await httpService.delete(`Accounts/delete?id=${user?.id}`, null, (res) => {
            notificationApi.success("user", {
               message: t("profile-picture-deleted-success-title"),
               description: t("profile-picture-deleted-success-description")
            });
         });
         setPreviewImage(UserIcon);
         setProfileImage(UserIcon);
         onCancel();
      } catch (error) {
         notificationApi.error("user", {
            message: t("generic-problem-occurred-title"),
            description: t("profile-picture-delete-error-description")
         });
      } finally {
         setLoading(false);
      }
   };

   const getProfilePic = async () => {
      setImageLoading(true);
      try {
         await httpService.get(`Accounts/get-profile-picture?userId=${user?.id}`, async (res) => {
            const fileKey = res?.message;

            if (fileKey) {
               const fileUrl = `${process.env.REACT_APP_FILE_MANAGEMENT}FileData/getFileByFileKey?platformId=${process.env.REACT_APP_PLATFORM_KEY}&fileKey=${fileKey}`;
               const response = await Axios.get(fileUrl);

               if (response?.data?.data) {
                  setPreviewImage(response?.data?.data);
                  setInitialImage(response?.data?.data);
               } else {
                  console.error("No image URL found in the file management response.");
               }
            } else {
               console.error("No file key found in the response.");
            }
         });
      } catch (error) {
         console.error("Error fetching profile picture:", error);
      } finally {
         setImageLoading(false);
      }
   };

   useEffect(() => {
      if (open) {
         getProfilePic();
      }
   }, [open]);

   const handleUpload = ({ file }) => {
      if (file) {
         setSelectedFile(file);
         setIsDeleted(false);
         setPreviewImage(URL.createObjectURL(file));
      }
   };

   const handleSaveChanges = async () => {
      if (isDeleted) {
         await deleteProfilePic();
      } else if (selectedFile) {
         await editProfilePic(selectedFile);
      }
   };

   const handleDelete = () => {
      setSelectedFile(null);
      setIsDeleted(true);
      setPreviewImage(UserIcon);
   };

   const handleCancel = () => {
      setSelectedFile(null);
      setPreviewImage(initialImage);
      setIsDeleted(false);
      onCancel();
   };

   return (
      <>
         {notificationContextHolder}
         <Modal
            open={open}
            onCancel={handleCancel}
            className="modalBox"
            destroyOnClose
            footer={null}
            maskClosable={!loading}
         >
            <div className="d-flex flex-column" style={{ gap: "32px" }}>
               <div
                  className="d-flex flex-column justify-content-center align-items-center"
                  style={{ gap: "32px", marginTop: "32px" }}
               >
                  <span
                     className="span-style"
                     style={{ color: "#4158CF", fontSize: "22px", fontWeight: 600 }}
                  >
                     {t("edit-profile-picture-title")}
                  </span>
                  <div
                     className="d-flex flex-column justify-content-center align-items-center"
                     style={{ gap: "24px", width: "100%" }}
                  >
                     {imageLoading ? (
                        <Spin />
                     ) : (
                        <img
                           src={previewImage || UserIcon}
                           alt="Profile Preview"
                           style={{ width: "150px", borderRadius: "50%", height: "150px" }}
                        />
                     )}

                     <div
                        className="d-flex flex-column justify-content-center align-items-center"
                        style={{ gap: "8px", width: "100%" }}
                     >
                        <ImgCrop rotationSlider>
                           <Upload
                              accept="image/png, image/jpeg"
                              name="file"
                              showUploadList={false}
                              beforeUpload={(file) => {
                                 handleUpload({ file });
                                 return false;
                              }}
                           >
                              <Button type="link" style={{ color: "#4158CF", padding: 0 }}>
                                 {t("change-profile-picture-button")}
                              </Button>
                           </Upload>
                        </ImgCrop>
                        <Button
                           type="link"
                           style={{ color: "#E31A32", padding: 0 }}
                           onClick={handleDelete}
                        >
                           {t("delete-profile-picture-button")}
                        </Button>
                     </div>
                     <hr style={{ width: "100%", height: "1px", backgroundColor: "#DFE6FF" }} />
                  </div>
               </div>
               <div className="footer-buttons" style={{ paddingTop: 0 }}>
                  <Button
                     className="cencel-add-assessment-button"
                     key="cancel"
                     onClick={loading ? null : handleCancel}
                  >
                     {t("cancel")}
                  </Button>
                  <Button
                     onClick={handleSaveChanges}
                     className="edit-button-workspace"
                     loading={loading}
                     disabled={
                        loading ||
                        (previewImage === UserIcon && isDeleted) ||
                        (previewImage === initialImage && !selectedFile)
                     }
                  >
                     {t("save-changes-button")}
                  </Button>
               </div>
            </div>
         </Modal>
      </>
   );
};

export default EditProfilePicture;
